<template>
  <div v-if="section">
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :sectionId="section_id"
      :showMatterProgram="true"
      :showPdaView="true"
      :showNewFullGradingView="true"
      :showAssessmentStudents="true"
      :showAssessmentRangeSectionView="true"
      :showProfessorProgressionReportView="true"
    ></NavigationBreadcrumb>
    <div class="mt-3 mb-2 px-3">
      <template v-if="section.egress_profile_matter != null">
        <h4>
          {{
            $t("dashboard.dashboardView.informationOfThe", {
              entity: $getVisibleNames(
                "mesh.egressprofilematter",
                false,
                "Asignatura"
              ),
            })
          }}
        </h4>
        <NewMatterPresentation
          class="mt-3"
          v-if="egress_profile_matter && matter"
          :Matter="egress_profile_matter"
          :oldMatter="matter"
        ></NewMatterPresentation>
      </template>
      <template v-else-if="section.matter != null">
        <h4>
          {{
            $t("dashboard.dashboardView.informationOfThe", {
              entity: $getVisibleNames(
                "teaching.matter",
                false,
                "Asignatura Base"
              ),
            })
          }}
        </h4>
        <NewMatterPresentation
          class="mt-3"
          v-if="matter"
          :oldMatter="matter"
        ></NewMatterPresentation>
      </template>
    </div>
    <div class="mt-2 mb-5">
      <h4>
        {{ $getVisibleNames("evaluations2.evaluation", true, "Evaluaciones") }}
      </h4>
      <div class="d-flex">
        <b-button
          v-can="'evaluations2.add_evaluation'"
          v-if="allows_crud"
          size="sm"
          variant="primary"
          @click="$bvModal.show('modal-created-evaluation')"
          class="mb-0 mt-0 ml-3 mr-auto"
          >{{ $t("reusable.common.add") }}
          {{
            $getVisibleNames("evaluations2.evaluation", false, "Evaluación")
          }}</b-button
        >
      </div>
      <ManageEvaluationTable
        :key="key_new_generic_table"
        :pre_filter="pre_filter"
        :evaluation_scoped="selected_evaluations_scoped"
        :evaluation_scoped_object_id="section_id"
        :Sections="[section]"
        :Matters="[]"
        :EgressProfileMatters="[]"
        :allows_crud="allows_crud"
        :reorderable="true"
      ></ManageEvaluationTable>
      <template v-if="matter">
        <ILIndicatorsUsage
          :key="evaluation_ids.join(',')"
          :matter_id="matter.id"
          :evaluations_ids="evaluation_ids"
          :fetch_evaluations="true"
          :fetch_evaluation_criteria_micro="true"
          :fetch_competence_unit="true"
        ></ILIndicatorsUsage>
      </template>
    </div>
    <b-modal
      :title="
        $t('reusable.common.create') +
        ' ' +
        $getVisibleNames('evaluations2.evaluation', false, 'Evaluación')
      "
      hide-footer
      size="xl"
      id="modal-created-evaluation"
    >
      <NewEvaluationForm
        :evaluation_scoped_id="selected_evaluations_scoped"
        :evaluation_scoped_object_id="section_id"
        :Sections="[section]"
        :Matters="[]"
        :EgressProfileMatters="[]"
        :show_step="selected_evaluations_scoped == 1"
        @closeModal="closeModal()"
      ></NewEvaluationForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "EvaluatorEvaluationsListView",
  components: {
    ManageEvaluationTable: () =>
      import(
        "@/components/new-evaluations/ManageEvaluations/ManageEvaluationTable"
      ),
    NewMatterPresentation: () =>
      import(
        "@/components/teaching/MatterProgram/Components/NewMatterPresentation.vue"
      ),
    NewEvaluationForm: () =>
      import(
        "@/components/new-evaluations/ManageEvaluations/NewEvaluationForm"
      ),
    ILIndicatorsUsage: () =>
      import(
        "@/components/teaching/MatterProgram/Components/ILIndicatorsUsage"
      ),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      section_id: Number(this.$route.params.section_id),
      selected_evaluations_scoped: 1,
      evaluation_ids: [],
      allows_crud: false,
      key_new_generic_table: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      sections: names.SECTIONS,
      egress_profile_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
    }),
    breadcrumb_items() {
      let breadcrumb = [
        {
          text: this.$t("reusable.breadcrumb.home"),
          to: "/home",
        },
      ];
      // Solo mostrar "Administrar Secciones" si NO es profesor
      if (this.user && !this.user.group_names.includes("PROFESORES")) {
        breadcrumb.push({
          text: this.$getVisibleNames(
            "manual.administrar_seccion",
            true,
            "Administrar Secciones"
          ),
          to: "/section/form",
        });
      }
      breadcrumb.push({
        text: this.$getVisibleNames(
          "evaluations2.evaluation",
          true,
          "Evaluaciones"
        ),
        dropdownOptions: [
          ...(this.institution && this.institution.internal_use_id == "duoc.cl"
            ? ["showPdaView"]
            : ["showMatterProgram"]),
          "showNewFullGradingView",
          "showAssessmentStudents",
          "showAssessmentRangeSectionView",
          "showProfessorProgressionReportView",
        ],
      });
      return breadcrumb;
    },
    section() {
      return this.sections.find((x) => x.id == this.section_id);
    },
    egress_profile_matter() {
      if (this.section && this.section.egress_profile_matter != null)
        return this.egress_profile_matters.find(
          (x) => x.id == this.section.egress_profile_matter
        );
      else return null;
    },
    matter() {
      if (this.section && this.section.matter != null)
        return this.matters.find((x) => x.id == this.section.matter);
      else if (
        this.egress_profile_matter &&
        this.egress_profile_matter.matter != null
      )
        return this.matters.find(
          (x) => x.id == this.egress_profile_matter.matter
        );
      else return null;
    },
    pre_filter() {
      let partial_url =
        "evaluation_scope_default__scope=" + this.selected_evaluations_scoped;
      if (this.section_id != null)
        partial_url =
          partial_url +
          "&evaluation_scope_default__scope_id=" +
          this.section_id;
      // filtro especial para ver si está como creador, o dentro del tests__test_users_default__evaluators__id
      if (this.user && this.user.group_names.includes("PROFESORES"))
        partial_url = partial_url + "&evaluator=" + this.user.id;
      // if (this.user)
      //   partial_url =
      //     partial_url +
      //     "&tests__test_users_default__evaluators__id=" +
      //     this.user.id;
      return partial_url;
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-created-evaluation");
      this.key_new_generic_table++;
    },
    fetchEvaluationDetails() {
      this.$restful
        .GetAll(`/evaluations2/evaluation/?${this.pre_filter}`)
        .then((evaluations) => {
          this.evaluation_ids = evaluations.map((x) => x.id);
        });
    },
  },
  mounted() {
    this.fetchEvaluationDetails();
  },
  created() {
    this.$store.dispatch(names.FETCH_NEW_EVALUATION_TYPES);
    this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
    this.$store
      .dispatch(names.FETCH_SECTION, this.section_id)
      .then((section) => {
        if (section.egress_profile_matter != null) {
          this.$store.dispatch(names.FETCH_SECTIONS, {
            egress_profile_matter_id: section.egress_profile_matter,
          });
          this.$store
            .dispatch(
              names.FETCH_EGRESS_PROFILE_MATTER,
              section.egress_profile_matter
            )
            .then((egress_profile_matter) => {
              this.$store.dispatch(
                names.FETCH_MATTER,
                egress_profile_matter.matter
              );
            });
        } else if (section.matter != null) {
          this.$store.dispatch(names.FETCH_MATTER, section.matter);
        }
        if (
          this.institution &&
          this.institution.internal_use_id != "duoc.cl" &&
          this.section
        ) {
          if (
            this.user &&
            !this.user.group_names.includes("ESTUDIANTES") &&
            this.section.is_active
          )
            this.allows_crud = true;
          this.$store.dispatch(names.FETCH_NEW_EVALUATIONS, {
            scoped_id: 1,
            scoped_object_id: this.section_id,
          });
        }
      });
  },
};
</script>

<style scoped>
</style>

